import { render } from "./UserReferralTreeview.vue?vue&type=template&id=28e509d4"
import script from "./UserReferralTreeview.vue?vue&type=script&lang=js"
export * from "./UserReferralTreeview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__